import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
const NumberInputStyles = styled.input.withConfig({
  displayName: "FloatInputField__NumberInputStyles",
  componentId: "sc-s0fcuc-0"
})(["width:4em;"]);
export const FloatInputField = ({
  disabled,
  style,
  onlyPositive,
  value,
  min,
  max,
  step,
  onChange,
  onMouseEnter,
  onMouseLeave
}) => {
  const [override, setOverride] = useState(null);
  const [valueSuffix, setValueSuffix] = useState("");
  useEffect(() => {
    if (value !== 0) {
      setOverride(null);
    }

    setValueSuffix("");
  }, [value]);

  const set = e => {
    let stringValue = e.target.value;

    if (stringValue.startsWith("-") && onlyPositive) {
      stringValue = "";
    }

    if (stringValue.endsWith(".")) {
      setValueSuffix(".");
    } else {
      setValueSuffix("");
    }

    if (stringValue === "" || stringValue === "-") {
      setOverride(stringValue);
    } else {
      setOverride(null);
    }

    let floatValue = parseFloat(stringValue) || 0;

    if (onlyPositive) {
      floatValue = Math.max(0, floatValue);
    }

    onChange(floatValue);
  };

  const displayValue = override !== null ? override + valueSuffix : (typeof value === "number" ? value.toString() : "") + valueSuffix;

  if (onlyPositive && !min) {
    min = 0;
  }

  return /*#__PURE__*/React.createElement(NumberInputStyles, {
    disabled: disabled,
    style: style,
    type: "number",
    value: displayValue,
    step: step || 0.1,
    min: min,
    max: max,
    onChange: set,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
};